function SplashScreen() {
    // const mainWrapper = document.querySelector('.jsMainWrapper');
    const splashScreen = document.querySelector('.jsSplashScreen');
    if (!splashScreen) return;

    const logo = document.querySelector('.jsSplashLogo');
    const strokedLetters = logo.querySelectorAll('.stroked path');
    const filledLettersGroup = logo.querySelector('.filled');

    new TimelineMax({ delay: 0.2 })
        // .set(mainWrapper, { opacity: 0 })
        .set(strokedLetters, { drawSVG: '0%' })
        .set(logo, { scale: 0.9 })
        .to(logo, 2, { scale: 1, opacity: 1, ease: 'power2.inOut' })
        .to(strokedLetters, 2, { drawSVG: '100%', ease: 'power2.inOut' }, '-=2')
        .to(filledLettersGroup, 0.5, { opacity: 1, ease: 'power2.easeOut' }, '-=0.3')
        .to(logo, 0.5, { scale: 0.9, opacity: 0, ease: 'power2.inOut' })
        .to(splashScreen, 0.8, { opacity: 0, ease: 'power2.inOut' })
        .set(splashScreen, { display: 'none' })
    ;
};

SplashScreen.prototype.shuffleArray = function(array) {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }

    return array;
};